import TransaksiSnapclean from "./views/TransaksiSnapclean";
import TransaksiSnapcleanDetail from "./views/TransaksiSnapcleanDetail";

const requireAuth = { requireAuth: true }
const route = {
	path: '/transaksi/snapclean', component: {
		render(c) {
			return c('router-view')
		}
	},
	children: [
		{
			path: '',
			name: "TransaksiSnapcleanGlobal",
			component: TransaksiSnapclean,
			meta: {
				...requireAuth,
				accessKey: 'transaction.selfService',
			},
		},
		{
			path: 'detail',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [
				{
					path: ':idsnap_transaksi',
					name: "TransaksiSnapcleanDetail",
					component: TransaksiSnapcleanDetail,
					meta: {
						...requireAuth,
						accessKey: 'selfService.read'
					}
				},
			]
		}
	]
}

export default router => {
	router.addRoutes([route])
}